import gql from 'graphql-tag';

import client from '../graphqlAPI';

const POST_EDIT_EVENT_MUTATION = gql`
  mutation Post(
    $artistSets: [String]
    $beginDateTime: String
    $description: ObjectLocalizationInput
    $endDateTime: String
    $eventsArray: [String]
    $eventName: String
    $eventReadableName: ObjectLocalizationInput
    $subtitle: ObjectLocalizationInput
    $pretitle: ObjectLocalizationInput
    $eventSlugName: String!
    $image: ObjectLocalizationInput
    $postSlugNames: [String]
    $tickets: [String]
    $totalCapacity: Int
    $salePostSlugName: String
    $venues: [String]
    $showDate: Boolean!
    $showDateTime: Boolean!
    $showTicket: Boolean!
    $showVenue: Boolean!
    $genres: [String]
    $timezone: String
    $mentors: [String]
  ) {
    postEditEvent(
      artistSets: $artistSets
      beginDateTime: $beginDateTime
      description: $description
      endDateTime: $endDateTime
      eventsArray: $eventsArray
      eventName: $eventName
      eventReadableName: $eventReadableName
      eventSlugName: $eventSlugName
      subtitle: $subtitle
      pretitle: $pretitle
      image: $image
      postSlugNames: $postSlugNames
      tickets: $tickets
      totalCapacity: $totalCapacity
      salePostSlugName: $salePostSlugName
      venues: $venues
      showDate: $showDate
      showDateTime: $showDateTime
      showTicket: $showTicket
      showVenue: $showVenue
      genres: $genres
      timezone: $timezone
      mentors: $mentors
    ) {
      isAuth
      isEdited
      eventSlugName
    }
  }
`;

const postEditEvent = async ({
  artistSets, beginDateTime, description, endDateTime, eventsArray, eventName, eventReadableName, subtitle, pretitle,
  eventSlugName, image, postSlugNames, tickets, totalCapacity, salePostSlugName, venues, showDate, showDateTime, showTicket, showVenue,
  genres, timezone, mentors,
}) => {
  try {
    const result = await client
      .mutate({
        mutation: POST_EDIT_EVENT_MUTATION,
        variables: {
          artistSets,
          beginDateTime,
          description,
          endDateTime,
          eventsArray,
          eventName,
          eventReadableName,
          subtitle,
          pretitle,
          eventSlugName,
          image,
          postSlugNames,
          tickets,
          totalCapacity,
          salePostSlugName,
          venues,
          showDate,
          showDateTime,
          showTicket,
          showVenue,
          genres,
          timezone,
          mentors,
        },
        fetchPolicy: 'no-cache',
      })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const {
      data: { postEditEvent: postEditEventValidationData },
    } = result;

    if (postEditEventValidationData) {
      return postEditEventValidationData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: postEditEventValidationData = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: postEditEvent Error: ${error}`);
    return null;
  }
};

export default postEditEvent;
